import { StartHOC } from 'testania';
import { compose } from 'redux';
import React, { useCallback } from 'react';

import { sendAnalyticForStartPage } from 'helpers/analytic/sendAnalyticForStartPage';

import StartContainer from 'containers/start/Start';

import { ICommonPageProps } from 'types/pages/startPages/commonTypes';

import OnboardingAnalytics from 'hocs/Analytic/Onboarding';

function IndexPage({ toNextPage, history, mirrorConfig }: ICommonPageProps) {
    const handleClick = useCallback(() => {
        sendAnalyticForStartPage(history);

        toNextPage();
    }, [history.location.pathname, toNextPage]);

    return <StartContainer mirrorConfig={mirrorConfig} toNextPage={handleClick} startPage={false} />;
}

export default compose<typeof IndexPage>(StartHOC, OnboardingAnalytics)(IndexPage);
